import React from 'react';

class RowItemKetQuaTiepCongDan extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tiepCongDanThuongXuyenLuot}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenNguoi}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenVuViecCu}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenVuViecMoiPhatSinh}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenDoanDongNguoiSoDoan}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu}</td>
        <td className='txt-center'>{data.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu}</td>
        <td className='txt-center'>{data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh}</td>
        <td className='txt-center'>{data.tongVuViecDonKhieuNaiLinhVucHanhChinh}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucTuPhap}</td>
        <td className='txt-center'>{data.donKhieuNaiLinhVucVeDang}</td>
        <td className='txt-center'>{data.tongVuViecDonToCao}</td>
        <td className='txt-center'>{data.donToCaoLinhVucHanhChinh}</td>
        <td className='txt-center'>{data.donToCaoLinhVucTuPhap}</td>
        <td className='txt-center'>{data.donToCaoLinhVucThamNhung}</td>
        <td className='txt-center'>{data.donToCaoLinhVucVeDang}</td>
        <td className='txt-center'>{data.donToCaoLinhVucKhac}</td>
        <td className='txt-center'>{data.phanAnhKienNghiKhac}</td>
        <td className='txt-center'>{data.chuaDuocGiaiQuyet}</td>
        <td className='txt-center'>{data.chuaCoQuyetDinhGiaiQuyet}</td>
        <td className='txt-center'>{data.daCoQuyetDinhGiaiQuyet}</td>
        <td className='txt-center'>{data.daCoBanAnCuaToa}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaTiepCongDan;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaTiepCongDan.jsx